<template>
  <template v-if="!isSubscriptionPage && !carIds.length && !isSearching">
    <div class="lg:flex lg:grid-cols-4 xl:gap-12 lg:gap-8">
      <div class="bg-white lg:col-span-1 lg:max-w-[22%] lg:block">
        &nbsp;
      </div>
      <div class="mx-auto pb-4 bg-white text-left lg:col-span-3 lg:max-w-[78%]">
        <div class="results">
          <div class="car-list px-4 lg:px-0">
            <NoResultsFound
              :noResultsLink="noResultsLink || ''"
              :isSubscriptionRequestFormActive="isSubscriptionRequestFormActive"
              :isSubscriptionPage="isSubscriptionPage"
              :formattedStartingFrom="formattedStartingFrom"
              :postal="postal"
              :resetSearch="resetSearch"
            />
          </div>
        </div>
      </div>
    </div>
  </template>

  <section class="max-w-container-2xl mx-auto lg:px-5 lg:pt-[70px] xl:px-16" v-if="!noAjax && !isSubscriptionPage && !hideLoader">
    <div class="heading">
      <h2 v-html="$t('layout.filters.we_are_checking_count_out_of_total_locations', { count: checkedCount, total: departmentsCount })"></h2>
      <div class="progress">
        <div class="progress-bar progress-bar-stripped progress-bar-animated" role="progressbar" :aria-valuenow="checkedCount" aria-valuemin="0" :aria-valuemax="departmentsCount" :style="`width: ${checkedCount / departmentsCount * 100}%`"></div>
      </div>
    </div>
  </section>

  <ais-instant-search v-if="isSubscriptionPage || (!isSubscriptionPage && carIds.length && filters && (cars.length || departmentsCount === 0 || isSearching === false))" :search-client="searchClient" :index-name="indexName" :class-names="{ 'ais-InstantSearch': 'max-w-container-2xl mx-auto lg:px-5 xl:px-16' }"  :middlewares="middlewares" :routing="routing">
    <ais-configure v-if="(coordinates && isSubscriptionPage) || !isSubscriptionPage" :filters="filters" :around-lat-lng.camel="coordinates" :minimum-around-radius.camel="minRadius * 1000" :around-radius.camel="radius * 1000" :get-ranking-info.camel="true" clickAnalytics="true" />
    <ais-configure v-else :filters="filters" :minimum-around-radius.camel="minRadius * 1000" :around-radius.camel="radius * 1000" :get-ranking-info.camel="true" clickAnalytics="true"  />
    <div class="lg:flex lg:grid-cols-4 xl:gap-12 lg:gap-8">
      <div class="bg-white lg:col-span-1 lg:max-w-[22%] lg:block">
        <h1 class="font-bold text-dark-blue-2 hidden text-[28px] lg:block">{{ $t('layout.filters.subscription.filters') }}</h1>
        <!-- Mobile Filter Button Start-->
        <div class="fixed bottom-6 left-0 right-0 !z-30 lg:hidden">
          <button type="button" class="mx-auto flex items-center gap-2 font-semibold text-base text-white py-3 px-6 rounded-full bg-[#232839]" @click="toggleFilters">
            {{ $t('layout.filters.subscription.filters') }} <img src="/assets/subscription/img/filter-icon.svg" alt="filter-icon">
          </button>
        </div>
        <!-- Mobile Filter Button End-->
        <!-- Filters Start (Mobile And Desktop)-->
        <div :class="{ 'bg-white': true, 'pb-6': true, 'opacity-0': true, 'invisible': true, 'fixed': true, 'w-full': true, '-left-96': true, 'top-0': true, 'lg:opacity-100': true, 'lg:visible': true, 'lg:relative': true, 'lg:left-0': true, 'active-bar': sidebarOpened, 'z-50': true, 'lg:z-0': true }"
          id="filter-bar">
          <div class="flex items-center px-5 py-4 border-b fixed w-full bg-white z-50 lg:hidden">
            <a id="filter-close" @click.prevent="toggleFilters()">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.5225 0L7.155 5.36625L1.78875 0L0 1.78875L5.36625 7.155L0 12.5213L1.78875 14.31L7.155 8.94375L12.5225 14.31L14.3113 12.5213L8.94501 7.155L14.3113 1.78875L12.5225 0Z" fill="#26272C"></path>
              </svg>
            </a>
            <p class="font-bold mx-auto leading-6 text-dark-blue-2 leading-4 pl-3 text-[17px]">{{ $t('layout.filters.subscription.filters') }}</p>
          </div>
          <ais-current-refinements :class-names="{'ais-CurrentRefinements': 'px-5 py-4 mt-16 lg:hidden'}">
            <template v-slot="{ items, createURL }">
              <ul class="flex flex-wrap gap-2 items-center">
                <template v-for="item in items">
                  <RefinementLabel
                    v-for="refinement in item.refinements"
                    :key="[refinement.attribute, refinement.type, refinement.value, refinement.operator].join(':')"
                    :refinement="refinement"
                    class-names="bg-grey-2 py-2 px-4 font-medium text-sm leading-5 rounded-full text-dark-blue-2 cursor-pointer">
                    <template v-slot:clear>
                        <span @click.prevent="resetPriceGraph(refinement.operator); item.refine(refinement);" v-if="isSubscriptionPage ? refinement.attribute === 'min_subscription_price' : refinement.attribute === 'min_day_price'">
                          <i class="fa fa-solid fa-xmark pl-3"></i>
                        </span>
                      <span @click.prevent="item.refine(refinement)" v-else>
                        <i class="fa fa-solid fa-xmark pl-3"></i>
                      </span>
                    </template>
                  </RefinementLabel>
                </template>
                <ais-clear-refinements v-if="items?.length" ref="clearRefinements">
                  <template v-slot="{ refine, canRefine, createURL }">
                    <li class="py-2 px-3 font-bold text-sm leading-5 rounded-full underline text-dark-blue-2 cursor-pointer md:text-base hover:!text-oscar-orange" id="clear-options" @click="refine(); resetPriceGraph();" v-if="canRefine">
                      {{ $t('layout.buttons.clear_filters') }}
                    </li>
                  </template>
                </ais-clear-refinements>
              </ul>
            </template>
          </ais-current-refinements>
          <div class="w-full py-4 px-6 lg:px-0">
            <!-- Search radius -->
            <div v-if="!isSubscriptionPage" class="pt-4 pb-8 border-b border-menu-b overflow-hidden">
              <div class="font-semibold flex justify-between items-center cursor-pointer leading-8 mb-3 !text-lg text-dark-blue-2">{{ $t('layout.filters.search_radius') }}</div>

              <div class="rental-range-slider pb-4">
                <input class="rental-range-slider__range" type="range" v-model="radius" :min="minRadius" :max="maxRadius" :style="`background: linear-gradient(90deg, rgb(35, 40, 57) ${(radius-minRadius)/(maxRadius-minRadius)*100}%, rgb(215, 220, 223) ${(radius-minRadius)/(maxRadius-minRadius)*100}%);`">
                <div class="inputkm-vlaue">
                  <label for="searchRadius">{{ $t('layout.filters.search_radius') }}</label>
                  <input id="searchRadius" class="rental-range-slider__value" type="number" v-model="radius" inputmode="decimal" :min="minRadius" @input="validateRadius" :max="minRadius" @keydown="onKeydownRadius">
                </div>
              </div>

              <div class="search-map-range">
                <ais-refinement-list :sort-by="geoSort" :attribute="`departments.name.${appLocale}`" :show-more="true" :limit="4">
                  <template v-slot:showMoreLabel="{ isShowingMore }">
                    {{ isShowingMore ? $t('layout.filters.show_less') : $t('layout.filters.show_more') }} <i :class="{'fa-solid': true, 'fa-chevron-down': !isShowingMore, 'fa-chevron-up': isShowingMore, 'pl-2': true}"></i>
                  </template>
                </ais-refinement-list>

                <div class="map-area relative hover-btn-orange mt-3">
                  <button class="button-orange absolute z-20 top-[30%] lg:top-[40%] left-0 right-0 mx-auto block text-center w-[195px] lg:!w-[135px]" @click="showDepartmentsMap()">{{ $t('layout.filters.search_on_map')}}</button>

                  <div class="w-full pointer-events-none">
                    <iframe class="rounded-lg pointer-events-none w-full !h-[120px] lg:!h-[145px] lg:max-w-[300px]" :src="`https://www.google.com/maps/embed/v1/view?key=${mapsApiKey}&center=${departments.length ? departments[0].lat + ',' + departments[0].lng : coordinates}&zoom=10`" width="100%" height="auto" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                  </div>

                  <dialog class="modal lg:px-3" id="my_map_1">
                    <div class="modal-box modal_car_popup md:!max-w-[1186px] xl:min-h-[793px] !max-h-full !w-full !max-w-full !rounded-none lg:!rounded-xl !p-0 !max-lg:h-full">
                      <div style="position: relative; overflow: hidden;" v-if="departmentsMapClicked">
                        <DepartmentsMap :department-ids="departmentIdsForMap" :departments="departments" :zoom="zoom" :latitude="latitude" :longitude="longitude" />
                      </div>
                      <div id="info-box"></div>
                      <form class="modal-backdrop" method="dialog">
                        <button class="w-10 h-10 shadow-xl bg-white rounded-full absolute text-3xl z-50 modal-close-content flex justify-center items-center !top-5 lg:!top-6 !right-5 lg:!right-14 block" tabindex="0">
                          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.07994 4.16566L5.37283 3.45856L3.95862 4.87277L4.66572 5.57988L10.9981 11.9122L4.66572 18.2446L3.95862 18.9517L5.37283 20.3659L6.07994 19.6588L12.4123 13.3264L18.7446 19.6588L19.4517 20.3659L20.8659 18.9517L20.1588 18.2446L13.8265 11.9122L20.1588 5.57988L20.8659 4.87277L19.4517 3.45856L18.7446 4.16566L12.4123 10.498L6.07994 4.16566Z" fill="#0B0D17"></path>
                          </svg>
                        </button>
                      </form>
                    </div>
                    <form class="modal-backdrop" method="dialog">
                      <button>close</button>
                    </form>
                  </dialog>
                </div>
              </div>
            </div>

            <!-- Price range -->
            <ais-panel :class-names="{'ais-Panel': 'pt-4 pb-8 border-b border-menu-b overflow-hidden'}">
              <template v-slot:header>
                <h4 class="font-semibold flex justify-between items-center cursor-pointer leading-8 mb-3 !text-lg text-dark-blue-2">
                  <template v-if="isSubscriptionPage">
                  {{ $t('layout.filters.subscription.price_range', {'currency': currency}) }}
                  </template>
                  <template v-else>
                    {{ $t('layout.filter.rental.price_range', {'currency': currency}) }}
                  </template>
                </h4>
              </template>
              <template v-slot:default>
                <ais-range-input :attribute="isSubscriptionPage ? 'min_subscription_price' : 'min_day_price'" :classNames="{'ais-RangeInput': 'price-range-content'}">
                  <template v-slot="{ currentRefinement, range, refine, canRefine }">
                    <div class="wrapper">
                      <div class="price-graph">
                        <img class="mb-[-1px]" src="/assets/subscription/img/graph.svg" alt="graph" ref="priceGraphEl">
                      </div>
                      <div class="price-range-slider">
                        <div class="price-progress" ref="rangeEl"></div>
                      </div>
                      <div class="range-input">
                        <input class="cursor-pointer"
                             type="range"
                             id="range-min"
                             :min="isSubscriptionPage ? normalizePriceToApp(range.min) : range.min"
                             :max="isSubscriptionPage ? normalizePriceToApp(range.max) : range.max"
                             v-model="rangeInputMin"
                             @touchend="refinePriceInput($event, { refineFn: refine, currentRefinement })"
                             @mouseup="refinePriceInput($event, { refineFn: refine, currentRefinement })"
                             ref="rangeInputMinEl"
                        />
                        <input class="cursor-pointer"
                             type="range"
                             id="range-max"
                             :min="isSubscriptionPage ? normalizePriceToApp(range.min) : range.min"
                             :max="isSubscriptionPage ? normalizePriceToApp(range.max) : range.max"
                             v-model="rangeInputMax"
                             @touchend="refinePriceInput($event, { refineFn: refine, currentRefinement })"
                             @mouseup="refinePriceInput($event, { refineFn: refine, currentRefinement })"
                             ref="rangeInputMaxEl"
                        />
                      </div>
                      <div class="price-input">
                        <div class="field relative">
                          <label class="text-light-blue-2 text-sm leading-4 absolute left-3 top-3">{{ $t('layout.filters.min') }}</label>
                          <input class="text-dark-blue-2 font-medium border border-light-border-grey rounded-lg"
                             type="text"
                             id="price-min"
                             v-model="priceInputMin"
                             :data-min="isSubscriptionPage ? normalizePriceToApp(range.min) : range.min"
                             :data-max="isSubscriptionPage ? normalizePriceToApp(range.max) : range.max"
                             @keyup="onKeyupPriceInput($event, { refineFn: refine, currentRefinement })"
                             @change="handlePriceInputChange($event, { refineFn: refine, currentRefinement })"
                          />
                        </div>
                        <div class="field relative">
                          <label class="text-light-blue-2 text-sm leading-4 absolute left-3 top-3">{{ $t('layout.filters.max') }}</label>
                          <input class="text-dark-blue-2 font-medium border border-light-border-grey rounded-lg"
                             type="text"
                             id="price-max"
                             v-model="priceInputMax"
                             :data-min="isSubscriptionPage ? normalizePriceToApp(range.min) : range.min"
                             :data-max="isSubscriptionPage ? normalizePriceToApp(range.max) : range.max"
                             @keyup="onKeyupPriceInput($event, { refineFn: refine, currentRefinement })"
                             @change="handlePriceInputChange($event, { refineFn: refine, currentRefinement })"
                          />
                        </div>
                      </div>
                    </div>
                  </template>
                </ais-range-input>
              </template>
            </ais-panel>
            <!-- Vehicle type -->
            <ais-panel :class-names="{'ais-Panel': 'price-range pt-4 pb-8 border-b border-menu-b vehicle-type'}">
              <template v-slot:header>
                <h4 class="font-semibold !text-[21px] pb-[18px]">{{ $t('layout.filters.car_types') }}</h4>
              </template>
              <template v-slot:default>
                <ais-refinement-list :attribute="`type.name.${appLocale}`" :show-more="true" :limit="5" :show-more-limit="100" :class-names="{
                    'ais-RefinementList-list': 'list-checkbox flex gap-2 mb-3 items-center car-select flex-wrap',
                    'ais-RefinementList-item': 'bg-white rounded-lg float-left',
                    'ais-RefinementList-showMore': 'text-sm font-bold leading-4 underline text-dark-blue-2 cursor-pointer ' + (!showMoreEnabled.carTypes ? 'hidden' : '')
                  }" :transform-items="transformItemsVehicleType" ref="vehicleTypeRefinementList">
                  <template v-slot:item="{ item, refine, createURL }">
                    <label class="h-auto cursor-pointer" @click.prevent="refine(item.value)">
                      <input class="absolute hidden !text-color-grey" type="checkbox" :value="item.label" :checked="item.isRefined">
                      <span class="border border-light-border-grey whitespace-pre rounded-lg block pt-4 pb-3 px-4 font-semibold w-full lg:py-[10px] lg:pl-2 pr-2 max-lg:pr-4 lg:flex lg:items-center lg:gap-3">
                        <img :src="`/assets/shared/img/icons/car_types/${getCarTypeIcon(item)}`" :alt="item.label">
                        <span class="text-left block text-sm font-medium">{{ item.label }}</span>
                      </span>
                    </label>
                  </template>
                  <template v-slot:showMoreLabel="{ isShowingMore }">
                    {{ isShowingMore ? $t('layout.filters.show_less') : $t('layout.filters.show_more') }} <i :class="{'fa-solid': true, 'fa-chevron-down': !isShowingMore, 'fa-chevron-up': isShowingMore, 'pl-2': true}"></i>
                  </template>
                </ais-refinement-list>
              </template>
            </ais-panel>
            <!-- Commitment period -->
            <ais-panel v-if="isSubscriptionPage" :class-names="{'ais-Panel': 'price-range pt-4 pb-8 border-b border-menu-b'}">
              <template v-slot:header>
                <h4 class="font-semibold !text-[21px] pb-[18px]">{{ $t('layout.filters.subscription.commitment_period') }}</h4>
              </template>
              <template v-slot:default>
                <ais-refinement-list :attribute="`commitment_period.${appLocale}`" :show-more="false" :class-names="{
                    'ais-RefinementList-list': 'list-checkbox flex overflow-auto gap-2 mb-3 items-center xll:flex-wrap max-lg:flex-wrap',
                    'ais-RefinementList-item': 'bg-white rounded-lg float-left',
                    'ais-RefinementList-showMore': 'hidden',
                    'ais-RefinementList-label': 'float-left w-auto h-auto cursor-pointer lg:w-auto',
                    'ais-RefinementList-checkbox': 'absolute hidden',
                    'ais-RefinementList-labelText': 'border border-light-border-grey whitespace-pre rounded-lg pt-3 pb-5 px-4 font-semibold text-left block text-light-blue-2 lg:min-w-[135px] lg:py-3',
                  }">
                  <template v-slot:item="{ item, refine, createURL }">
                    <label class="float-left w-auto h-auto cursor-pointer lg:w-auto" @click.prevent="refine(item.value)">
                      <input class="absolute hidden" type="checkbox" :value="item.value" name="subscription" :checked="item.isRefined">
                      <span class="border border-light-border-grey whitespace-pre rounded-lg pt-3 pb-5 px-4 font-semibold text-left block text-light-blue-2 lg:min-w-[135px] lg:py-3">
                        {{ item.label }}
                        <span class="text-left block text-dark-blue-2 font-semibold text-sm" v-if="lowestPrice[parseInt(item.value)] !== undefined">{{ $t('layout.labels.from') }} {{ formatPrice(lowestPrice[parseInt(item.value)]) }}</span>
                      </span>
                    </label>
                  </template>
                </ais-refinement-list>
              </template>
            </ais-panel>
            <!-- Tow hook -->
            <ais-panel :class-names="{'ais-Panel': 'price-range pt-10 pb-8 border-b border-menu-b'}">
              <template v-slot:header>
                <h4 class="font-semibold !text-[21px] pb-[18px]">{{ $t('layout.filters.towhook') }}</h4>
              </template>
              <template v-slot:default>
                <ais-toggle-refinement attribute="has_tow_hook" :label="''" :class-names="{'ais-ToggleRefinement': 'relative flex items-center cursor-pointer justify-between'}">
                  <template v-slot="{ value, refine }">
                    <span class="mr-3 text-base font-medium text-gray-900">{{ $t('layout.filters.subscription.only_tow_hook') }}</span>
                    <label class="relative" @click.prevent="refine(value)">
                      <input class="sr-only peer" type="checkbox" :value="value" :checked="value.isRefined">
                      <div class="cursor-pointer h-8 rounded-full peer w-[61px] bg-[#B1B1B1] peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-[#B1B1B1] after:border after:rounded-full after:h-7 after:w-7 after:transition-all peer-checked:bg-oscar-blue"></div>
                    </label>
                  </template>
                </ais-toggle-refinement>
              </template>
            </ais-panel>
            <!-- Brand -->
            <ais-panel :class-names="{'ais-Panel': 'price-range pt-4 pb-8 border-b border-menu-b'}">
              <template v-slot:header>
                <h4 class="font-semibold !text-[21px] pb-[18px]">{{ $t('layout.filters.brand') }}</h4>
              </template>
              <template v-slot:default>
                <ais-refinement-list :searchable="true" attribute="brand.name" :show-more="true" :limit="5" :show-more-limit="100" :transform-items="transformItemsBrand" ref="brandRefinementList">
                  <template v-slot="{ items, refine, searchForItems, searchForFacetValuesQuery, searchForFacetValues, isShowingMore, toggleShowMore, canToggleShowMore  }">
                    <div>
                      <!-- Search -->
                      <div class="relative mb-2">
                        <div class="pointer-events-none absolute inset-y-0 left-3 flex items-center pl-3">
                          <span class="text-gray-500 sm:text-sm">
                            <i class="fa-solid fa-magnifying-glass"></i>
                          </span>
                        </div>
                        <input class="text-base font-medium ring-1 ring-inset ring-light-border-grey rounded-lg pl-14 pr-4 w-full focus:ring-1 focus:ring-inset focus:ring-light-border-grey py-[18px] placeholder:text-gray-400 placeholder:text-light-blue-2" id="price" type="text" name="price" :placeholder="$t('layout.filters.placeholder_brand')" @input="searchForItems($event.target.value)">
                      </div>
                      <!-- List -->
                      <ul>
                        <li class="form-control py-3" v-for="item in items" @click="refine(item.value)" :key="item.value">
                          <div class="inline-flex items-center justify-between">
                            <label class="mt-px font-normal text-light-blue-2 cursor-pointer select-none leading-4">
                              <span class="label-text text-dark-blue-2 font-medium text-base">
                                {{ item.label }}
                                <span class="ml-2 bg-light-grey-2 px-2 rounded-full text-xs text-light-blue-2 py-[1px]">{{ item.count }}</span>
                              </span>
                            </label>
                            <label class="relative flex items-center rounded-full cursor-pointer" :for="item.label">
                              <input class="peer relative h-6 w-6 cursor-pointer appearance-none border border-dark-blue-2 transition-all min-w-[24px] rounded-[4px] checked:bg-dark-blue-2 focus:shadow-none focus:border-0" :id="item.label" type="checkbox" :checked="item.isRefined">
                              <span class="absolute text-white transition-opacity opacity-0 pointer-events-none top-[7px] left-[6px] peer-checked:opacity-100">
                                <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1.5 5L5 8.5L12 1.5" stroke="white" stroke-width="2"></path>
                                </svg>
                              </span>
                            </label>
                          </div>
                        </li>
                      </ul>
                      <a class="text-sm font-bold leading-4 underline text-dark-blue-2 cursor-pointer" @click="toggleShowMore" v-if="canToggleShowMore">
                        {{ isShowingMore ? $t('layout.filters.show_less') : $t('layout.filters.show_more') }} <i :class="{'fa-solid': true, 'fa-chevron-down': !isShowingMore, 'fa-chevron-up': isShowingMore, 'pl-2': true}"></i>
                      </a>
                    </div>
                  </template>
                </ais-refinement-list>
              </template>
            </ais-panel>
            <!-- Fuel Type -->
            <ais-panel :class-names="{'ais-Panel': 'price-range pt-4 pb-8 border-b border-menu-b'}">
              <template v-slot:header>
                <h4 class="font-semibold !text-[21px] pb-[18px]">{{ $t('layout.filters.fuel_type') }}</h4>
              </template>
              <template v-slot:default>
                <ais-refinement-list :searchable="true" :attribute="`fuel_type.${appLocale}`" :show-more="true" :limit="5" :show-more-limit="100" :transform-items="transformItemsFuelType">
                  <template v-slot="{ items, refine, searchForItems, searchForFacetValuesQuery, searchForFacetValues, isShowingMore, toggleShowMore, canToggleShowMore  }">
                    <div>
                      <!-- List -->
                      <ul>
                        <li class="form-control py-3" v-for="item in items" @click="refine(item.value)" :key="item.value">
                          <div class="inline-flex items-center justify-between">
                            <label class="mt-px font-normal text-light-blue-2 cursor-pointer select-none leading-4">
                              <span class="label-text text-dark-blue-2 font-medium text-base">
                                {{ item.label }}
                                <span class="ml-2 bg-light-grey-2 px-2 rounded-full text-xs text-light-blue-2 py-[1px]">{{ item.count }}</span>
                              </span>
                            </label>
                            <label class="relative flex items-center rounded-full cursor-pointer" :for="item.label">
                              <input class="peer relative h-6 w-6 cursor-pointer appearance-none border border-dark-blue-2 transition-all min-w-[24px] rounded-[4px] checked:bg-dark-blue-2 focus:shadow-none focus:border-0" :id="item.label" type="checkbox" :checked="item.isRefined">
                              <span class="absolute text-white transition-opacity opacity-0 pointer-events-none top-[7px] left-[6px] peer-checked:opacity-100">
                                <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1.5 5L5 8.5L12 1.5" stroke="white" stroke-width="2"></path>
                                </svg>
                              </span>
                            </label>
                          </div>
                        </li>
                      </ul>
                      <a class="text-sm font-bold leading-4 underline text-dark-blue-2 cursor-pointer" @click="toggleShowMore" v-if="showMoreEnabled.fuel_type">
                        {{ isShowingMore ? $t('layout.filters.show_less') : $t('layout.filters.show_more') }} <i :class="{'fa-solid': true, 'fa-chevron-down': !isShowingMore, 'fa-chevron-up': isShowingMore, 'pl-2': true}"></i>
                      </a>
                    </div>
                  </template>
                </ais-refinement-list>
              </template>
            </ais-panel>
            <!-- Seats and doors -->
            <ais-panel :class-names="{'ais-Panel': 'price-range pt-4 pb-8 border-b border-menu-b'}">
              <template v-slot:header>
                <h4 class="font-semibold pb-6 !text-[21px]">{{ $t('layout.filters.seats') }}</h4>
              </template>
              <template v-slot:default>
                <!-- Seats -->
                <ais-refinement-list attribute="seats" :sort-by="['isRefined', 'name:desc']">
                  <template v-slot="{ items, refine }">
                    <div>
                      <p class="font-bold text-dark-blue-2 leading-6 pb-5 text-[17px]">{{ $t('layout.filters.seats') }}</p>
                      <ul class="list-checkbox flex overflow-auto gap-3 mb-3 items-center xll:flex-wrap max-lg:flex-wrap">
                        <li class="bg-white float-left !rounded-full" v-for="item in items" :key="item.value">
                          <label class="float-left h-auto cursor-pointer lg:w-auto" @click.prevent="refine(item.value)" :for="item.label">
                            <input class="absolute hidden !text-color-grey" type="checkbox" :value="item.value" :checked="item.isRefined" :id="item.label">
                            <span class="border border-light-border-grey whitespace-pre block py-2 px-5 font-semibold !rounded-full">
                              <span class="text-left block text-sm">{{ item.label }}</span>
                            </span>
                          </label>
                        </li>
                      </ul>
                    </div>
                  </template>
                </ais-refinement-list>
                <!-- Doors -->
                <ais-refinement-list attribute="doors" :sort-by="['isRefined', 'name:desc']">
                  <template v-slot="{ items, refine }">
                    <div>
                      <p class="font-bold text-dark-blue-2 leading-6 pb-5 text-[17px]">{{ $t('layout.filters.doors') }}</p>
                      <ul class="list-checkbox flex overflow-auto gap-3 mb-3 items-center xll:flex-wrap max-lg:flex-wrap">
                        <li class="bg-white float-left !rounded-full" v-for="item in items" :key="item.value">
                          <label class="float-left h-auto cursor-pointer lg:w-auto" @click.prevent="refine(item.value)" :for="item.label">
                            <input class="absolute hidden !text-color-grey" type="checkbox" :value="item.value" :checked="item.isRefined" :id="item.label">
                            <span class="border border-light-border-grey whitespace-pre block py-2 px-5 font-semibold !rounded-full">
                              <span class="text-left block text-sm">{{ item.label }}</span>
                            </span>
                          </label>
                        </li>
                      </ul>
                    </div>
                  </template>
                </ais-refinement-list>
              </template>
            </ais-panel>
            <!-- Features -->
            <ais-panel :class-names="{'ais-Panel': 'price-range pt-4 pb-8 border-b border-menu-b'}">
              <template v-slot:header>
                <h4 class="font-semibold !text-[21px] pb-[18px]">{{ $t('layout.filters.features') }}</h4>
              </template>
              <template v-slot:default>
                <ais-refinement-list :searchable="false" :attribute="`features.${appLocale}`" operator="and" :show-more="true" :limit="5" :show-more-limit="100" :transform-items="transformItemsFeatures">
                  <template v-slot="{ items, refine, isShowingMore, toggleShowMore, canToggleShowMore  }">
                    <div>
                      <ul>
                        <li class="form-control py-3" v-for="item in items" @click="refine(item.value)" :key="item.value">
                          <div class="inline-flex items-center justify-between">
                            <label class="mt-px font-normal text-light-blue-2 cursor-pointer select-none leading-4">
                              <span class="label-text text-dark-blue-2 font-medium text-base">
                                {{ item.label }}
                                <span class="ml-2 bg-light-grey-2 px-2 rounded-full text-xs text-light-blue-2 py-[1px]">{{ item.count }}</span>
                              </span>
                            </label>
                            <label class="relative flex items-center rounded-full cursor-pointer" :for="item.label">
                              <input class="peer relative h-6 w-6 cursor-pointer appearance-none border border-dark-blue-2 transition-all min-w-[24px] rounded-[4px] checked:bg-dark-blue-2 focus:shadow-none focus:border-0" :id="item.label" type="checkbox" :checked="item.isRefined">
                              <span class="absolute text-white transition-opacity opacity-0 pointer-events-none top-[7px] left-[6px] peer-checked:opacity-100">
                                <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1.5 5L5 8.5L12 1.5" stroke="white" stroke-width="2"></path>
                                </svg>
                              </span>
                            </label>
                          </div>
                        </li>
                      </ul>
                      <a class="text-sm font-bold leading-4 underline text-dark-blue-2 cursor-pointer" @click.prevent="toggleShowMore" v-if="showMoreEnabled.features">
                        {{ isShowingMore ? $t('layout.filters.show_less') : $t('layout.filters.show_more') }} <i :class="{'fa-solid': true, 'fa-chevron-down': !isShowingMore, 'fa-chevron-up': isShowingMore, 'pl-2': true}"></i>
                      </a>
                    </div>
                  </template>
                </ais-refinement-list>
              </template>
            </ais-panel>
            <!-- Transmission Type -->
            <ais-panel :class-names="{'ais-Panel': 'price-range pt-4 pb-8 border-b border-menu-b'}">
              <template v-slot:header>
                <h4 class="font-semibold !text-[21px] pb-[18px]">{{ $t('layout.filters.transmission') }}</h4>
              </template>
              <template v-slot:default>
                <ais-refinement-list :attribute="`transmission.${appLocale}`">
                  <template v-slot="{ items, refine }">
                    <div>
                      <ul>
                        <li class="form-control py-3" v-for="item in items" @click="refine(item.value)" :key="item.value">
                          <label class="cursor-pointer flex justify-between items-center !px-0">
                            <span class="label-text text-dark-blue-2 font-medium text-base">{{ item.label }}
                              <span class="ml-2 bg-light-grey-2 px-2 rounded-full text-xs text-light-blue-2 py-[1px]">{{ item.count }}</span>
                            </span>
                            <label class="relative flex items-center rounded-full cursor-pointer">
                              <input class="peer relative h-6 w-6 cursor-pointer appearance-none border border-dark-blue-2 transition-all min-w-[24px] rounded-[4px] checked:bg-dark-blue-2 focus:shadow-none focus:border-0" type="checkbox">
                              <span class="absolute text-white transition-opacity opacity-0 pointer-events-none top-[7px] left-[6px] peer-checked:opacity-100">
                                <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1.5 5L5 8.5L12 1.5" stroke="white" stroke-width="2"></path>
                                </svg>
                              </span>
                            </label>
                          </label>
                        </li>
                      </ul>
                    </div>
                  </template>
                </ais-refinement-list>
              </template>
            </ais-panel>
          </div>
        </div>
        <!-- Filters End (Mobile And Desktop)-->
      </div>
      <div class="mx-auto pb-4 bg-white text-left lg:col-span-3 lg:max-w-[78%]">
        <h2 class="hidden text-[#232527] lg:block" :class="{'font-medium text-2xl hidden': !isSubscriptionPage, 'font-bold text-3xl': isSubscriptionPage}" v-show="algoliaCars.length">
          <ais-stats class="results__heading">
            <template v-slot="{ nbHits }" v-if="isSubscriptionPage">
              <p v-html="$t('layout.filters.subscription.results_found_heading', { hits: nbHits })"></p>
            </template>
            <template v-slot="{ nbHits }" v-if="!isSubscriptionPage">
              <p v-html="$t('layout.rental.search.result_found_heading', { count: nbHits, department: this.postal, dateRange: this.generateDateRange(false), days: daysCount })"></p>
            </template>
          </ais-stats>
        </h2>
        <div class="lg:block" :class="{'lg:mt-5': !isSubscriptionPage}">
          <ais-sort-by :items="sortByOptions" v-show="algoliaCars.length && isSubscriptionPage">
            <template v-slot="{ items, currentRefinement, refine }" >
              <ul class="list-checkbox no-scroll flex block overflow-auto mb-3 ml-0 lg:ml-0 lg:mt-5 px-4">
                <li class="bg-white text-base leading-6 font-normal flex items-center text-tag-grey max-lg:hidden">{{ $t('layout.filters.subscription.sort_by') }}</li>
                <li :class="{'m-1 bg-white rounded-lg float-left': true}" v-for="(item, index) in items" :key="item.value">
                  <label class="float-left w-auto h-auto cursor-pointer" @click="refine(item.value); $event.target.checked = !$event.target.checked;">
                    <input class="absolute hidden !text-color-grey" type="checkbox" value="1" name="filter" :checked="currentRefinement === item.value">
                    <span class="border border-light-border-grey whitespace-pre rounded-lg text-center block py-2 px-4 font-medium text-sm text-light-blue-2">{{ item.label }}</span>
                  </label>
                </li>
              </ul>
            </template>
          </ais-sort-by>
          <!-- Errors -->
          <Nudge
            v-for="(error, key) in errors"
            class="!mt-0 mb-5"
            :key="key"
            :text="error"
            bg-color="#FFEEEC"
            color="#CF1900"
            icon="error.svg"
            :icon-alt="error"
          />
          <Nudge
            v-if="showingFutureCars"
            class="!mt-0 mb-5"
            :text="$t('subscription_search.showing_future_cars')"
            bg-color="#FEF5E0"
            color="#F18A10"
            icon="occupancy.svg"
            icon-alt="occupancy"
          />
          <div class="h-auto px-4 py-3 rounded-lg justify-start items-center gap-2 mb-4 mx-6 hidden md:flex lg:mx-0 bg-[#F1F3FA]" v-show="nudgeHide.hideInfoBox && algoliaCars.length">
            <span class="w-6 h-auto relative">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 11C0 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11ZM20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11ZM12.0036 12.9984H13.003V14.9984H9.00297V12.9984H10.003V10.9984H9.00297V8.99839H12.0036V12.9984ZM12.0007 6.99839C12.0007 7.55067 11.5528 7.99839 11.0003 7.99839C10.4479 7.99839 10 7.55067 10 6.99839C10 6.4461 10.4479 5.99839 11.0003 5.99839C11.5528 5.99839 12.0007 6.4461 12.0007 6.99839Z" fill="#000B40"></path>
              </svg>
            </span>
            <div class="w-[96%]">
              <p class="flex items-center gap-2 justify-between">
                <span class="text-sm font-normal leading-normal text-[#17275B]">{{ $t('layout.subscription.info_alert') }}</span>
                <button class="cursor-poniter" @click="nudgeHide.hideInfoBox = !nudgeHide.hideInfoBox">
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.5225 0L7.155 5.36625L1.78875 0L0 1.78875L5.36625 7.155L0 12.5213L1.78875 14.31L7.155 8.94375L12.5225 14.31L14.3113 12.5213L8.94501 7.155L14.3113 1.78875L12.5225 0Z" fill="#17275B"></path>
                  </svg>
                </button>
              </p>
            </div>
          </div>
          <div class="h-auto px-4 py-3 rounded-lg justify-start items-center gap-2 mb-4 mx-6 hidden md:flex lg:mx-0 bg-[#FEF5E0]" v-show="nudgeHide.noResult && carIds.length === 0 && (postal !== '' || startingFrom)">
            <span class="w-6 h-auto relative">
              <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M21.4424 13.9532L14.4371 1.97762C13.7338 0.758398 12.4229 0.00166216 11.0053 2.73545e-06C9.58755 -0.00165687 8.27626 0.751956 7.56422 1.97767L0.55628 13.9576C-0.170394 15.1795 -0.186834 16.7105 0.517031 17.9592C1.22148 19.2089 2.54051 19.9866 3.97525 19.9983L18.0131 19.9983C19.4628 19.9842 20.7793 19.2089 21.4836 17.9603C22.1871 16.7132 22.1714 15.1856 21.4424 13.9532ZM2.27894 14.9737L9.29206 2.98491C9.64723 2.37354 10.2986 1.99918 11.003 2C11.7073 2.00083 12.3584 2.37673 12.7077 2.98222L19.7186 14.9672C20.086 15.5885 20.0939 16.3533 19.7417 16.9777C19.389 17.603 18.7295 17.9913 18.0034 17.9984L3.98339 17.9983C3.27278 17.9925 2.61208 17.6029 2.25929 16.9771C1.90689 16.3519 1.91512 15.5855 2.27894 14.9737ZM11.0012 15.9983C11.5537 15.9983 12.0015 15.5506 12.0015 14.9983C12.0015 14.4461 11.5537 13.9983 11.0012 13.9983C10.4487 13.9983 10.0009 14.4461 10.0009 14.9983C10.0009 15.5506 10.4487 15.9983 11.0012 15.9983ZM12.0045 5.99835H10.0038V12.9983H12.0045V5.99835Z" fill="#F18A10"/>
              </svg>
            </span>
            <div class="w-[96%]">
              <p class="flex items-center gap-2 justify-between">
                <span class="text-sm font-normal leading-normal text-[#F18A10]">
                  {{ $t('layout.subscription.no_cars_available', {'city': postal}) }}
                </span>
                <button class="cursor-pointer" @click="nudgeHide.noResult = !nudgeHide.noResult">
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.5225 0L7.155 5.36625L1.78875 0L0 1.78875L5.36625 7.155L0 12.5213L1.78875 14.31L7.155 8.94375L12.5225 14.31L14.3113 12.5213L8.94501 7.155L14.3113 1.78875L12.5225 0Z" fill="#F18A10"></path>
                  </svg>
                </button>
              </p>
            </div>
          </div>
          <NudgesBlock
            v-if="availableCarsCount && !isSubscriptionPage"
            :location="postal"
            :available-cars-count="availableCarsCount"
            :cars-min-total="carsMinTotal"
            :visible-cars-count="visibleCarsCount"
            :suggested-extension-discount="suggestedExtensionDiscount"
            :secure-for-fee-data="secureForFeeData"
            :is-weekend-booking="isWeekendBooking"
          />
          <ais-current-refinements :class-names="{'ais-CurrentRefinements': 'hidden lg:block'}" :transform-items="transformCurrentRefinements">
            <template v-slot="{ items, createURL }">
              <ul class="flex flex-wrap gap-2 items-center mt-4 current-refinements-list">
                <template v-for="item in items">
                  <RefinementLabel v-for="refinement in item.refinements" :key="[refinement.attribute, refinement.type, refinement.value, refinement.operator].join(':')" :refinement="refinement" class-names="bg-grey-2 py-2 px-4 font-medium text-sm leading-5 rounded-full text-dark-blue-2 cursor-pointer">
                    <template v-slot:clear>
                      <span @click.prevent="resetPriceGraph(refinement.operator); item.refine(refinement);" v-if="isSubscriptionPage ? refinement.attribute === 'min_subscription_price' : 'min_day_price'">
                        <i class="fa fa-solid fa-xmark pl-3"></i>
                      </span>
                      <span @click.prevent="item.refine(refinement)" v-else>
                        <i class="fa fa-solid fa-xmark pl-3"></i>
                      </span>
                    </template>
                  </RefinementLabel>
                </template>
                <ais-clear-refinements v-if="items?.length">
                  <template v-slot="{ items, refine, createURL }">
                    <li class="py-2 px-3 font-bold text-sm leading-5 rounded-full underline text-dark-blue-2 cursor-pointer md:text-base hover:!text-oscar-orange" id="clear-options" @click.prevent="refine(); resetPriceGraph();">
                      {{ $t('layout.buttons.clear_filters') }}
                    </li>
                  </template>
                </ais-clear-refinements>
              </ul>
            </template>
          </ais-current-refinements>
          <div class="results">

            <div class="desktop-skeleton max-md:hidden max-lg:px-4" :class="{ 'hidden': hideLoader && !isSearching}">
              <svg id="eEiulrxoc981" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewbox="0 0 978 900" shape-rendering="geometricPrecision" text-rendering="geometricPrecision"><defs><linearGradient id="eEiulrxoc9893-fill" x1="0" y1="0.5" x2="1" y2="0.5" spreadmethod="pad" gradientunits="objectBoundingBox" gradienttransform="translate(0 0)"><stop id="eEiulrxoc9893-fill-0" offset="0%" stop-color="rgba(255,255,255,0)"></stop><stop id="eEiulrxoc9893-fill-1" offset="38%" stop-color="rgba(255,255,255,0.6078431372549019)"></stop><stop id="eEiulrxoc9893-fill-2" offset="51%" stop-color="rgba(255,255,255,0.75)"></stop><stop id="eEiulrxoc9893-fill-3" offset="63%" stop-color="rgba(255,255,255,0.59)"></stop><stop id="eEiulrxoc9893-fill-4" offset="100%" stop-color="rgba(255,255,255,0)"></stop></linearGradient></defs><rect width="977" height="280" rx="19.5" ry="19.5" transform="translate(.5 0.5)" fill="none" stroke="#f1f1f4"></rect><rect width="229" height="138" rx="12" ry="12" transform="translate(16 20)" fill="#f1f1f4"></rect><rect width="123" height="17" rx="3" ry="3" transform="translate(253 25)" fill="#f1f1f4"></rect><rect width="156" height="28" rx="3" ry="3" transform="translate(253 50)" fill="#f1f1f4"></rect><rect width="123" height="17" rx="3" ry="3" transform="translate(253 86)" fill="#f1f1f4"></rect><line x1="253" y1="112.5" x2="774" y2="112.5" fill="none" stroke="#f1f1f4"></line><rect width="286" height="24" rx="3" ry="3" transform="translate(253 123)" fill="#f1f1f4"></rect><rect width="286" height="24" rx="3" ry="3" transform="translate(253 159)" fill="#f1f1f4"></rect><line x1="253" y1="192.5" x2="774" y2="192.5" fill="none" stroke="#f1f1f4"></line><rect width="106" height="38" rx="3" ry="3" transform="translate(253 203)" fill="#f1f1f4"></rect><rect width="106" height="38" rx="3" ry="3" transform="translate(519.5 203)" fill="#f1f1f4"></rect><line x1="774.5" y1="20" x2="774.5" y2="234" fill="none" stroke="#f1f1f4"></line><rect width="180" height="28" rx="3" ry="3" transform="translate(782 62)" fill="#f1f1f4"></rect><rect width="70" height="28" rx="3" ry="3" transform="translate(892 94)" fill="#f1f1f4"></rect><rect width="180" height="50" rx="3" ry="3" transform="translate(782 142)" fill="#f1f1f4"></rect><rect width="977" height="280" rx="19.5" ry="19.5" transform="translate(.5 296.5)" fill="none" stroke="#f1f1f4"></rect><rect width="229" height="138" rx="12" ry="12" transform="translate(16 316)" fill="#f1f1f4"></rect><rect width="123" height="17" rx="3" ry="3" transform="translate(253 321)" fill="#f1f1f4"></rect><rect width="156" height="28" rx="3" ry="3" transform="translate(253 346)" fill="#f1f1f4"></rect><rect width="123" height="17" rx="3" ry="3" transform="translate(253 382)" fill="#f1f1f4"></rect><line x1="253" y1="408.5" x2="774" y2="408.5" fill="none" stroke="#f1f1f4"></line><rect width="286" height="24" rx="3" ry="3" transform="translate(253 419)" fill="#f1f1f4"></rect><rect width="286" height="24" rx="3" ry="3" transform="translate(253 455)" fill="#f1f1f4"></rect><line x1="253" y1="488.5" x2="774" y2="488.5" fill="none" stroke="#f1f1f4"></line><rect width="106" height="38" rx="3" ry="3" transform="translate(253 499)" fill="#f1f1f4"></rect><rect width="106" height="38" rx="3" ry="3" transform="translate(519.5 499)" fill="#f1f1f4"></rect><line x1="774.5" y1="316" x2="774.5" y2="530" fill="none" stroke="#f1f1f4"></line><rect width="180" height="28" rx="3" ry="3" transform="translate(782 358)" fill="#f1f1f4"></rect><rect width="70" height="28" rx="3" ry="3" transform="translate(892 390)" fill="#f1f1f4"></rect><rect width="180" height="50" rx="3" ry="3" transform="translate(782 438)" fill="#f1f1f4"></rect><rect width="977" height="253" rx="19.5" ry="19.5" transform="translate(.5 592.5)" fill="none" stroke="#f1f1f4"></rect><rect width="229" height="138" rx="12" ry="12" transform="translate(16 612)" fill="#f1f1f4"></rect><rect width="123" height="17" rx="3" ry="3" transform="translate(253 617)" fill="#f1f1f4"></rect><rect width="156" height="28" rx="3" ry="3" transform="translate(253 642)" fill="#f1f1f4"></rect><rect width="123" height="17" rx="3" ry="3" transform="translate(253 678)" fill="#f1f1f4"></rect><line x1="253" y1="704.5" x2="774" y2="704.5" fill="none" stroke="#f1f1f4"></line><rect width="286" height="24" rx="3" ry="3" transform="translate(253 715)" fill="#f1f1f4"></rect><rect width="286" height="24" rx="3" ry="3" transform="translate(253 751)" fill="#f1f1f4"></rect><line x1="253" y1="784.5" x2="774" y2="784.5" fill="none" stroke="#f1f1f4"></line><rect width="106" height="38" rx="3" ry="3" transform="translate(253 795)" fill="#f1f1f4"></rect><rect width="106" height="38" rx="3" ry="3" transform="translate(519.5 795)" fill="#f1f1f4"></rect><line x1="774.5" y1="612" x2="774.5" y2="826" fill="none" stroke="#f1f1f4"></line><rect width="180" height="28" rx="3" ry="3" transform="translate(782 654)" fill="#f1f1f4"></rect><rect width="70" height="28" rx="3" ry="3" transform="translate(892 686)" fill="#f1f1f4"></rect><rect width="180" height="50" rx="3" ry="3" transform="translate(782 734)" fill="#f1f1f4"></rect><rect id="eEiulrxoc9893" width="253" height="600" rx="0" ry="0" transform="matrix(1.212961 0 0 1.046438-248.598812-41.2942)" fill="url(#eEiulrxoc9893-fill)" stroke-width="0"></rect></svg>
            </div>

            <div class="car-list px-4 lg:px-0">
              <ais-infiniteHits :transform-items="handleCarsFromAlgolia" :class-names="{ 'ais-InfiniteHits': 'results__cars' }">
                <template v-slot="{ items, refineNext, isLastPage, sendEvent }">
                  <NoResultsFound
                    :noResultsLink="noResultsLink || ''"
                    :isSubscriptionRequestFormActive="isSubscriptionRequestFormActive"
                    :isSubscriptionPage="isSubscriptionPage"
                    :formattedStartingFrom="formattedStartingFrom"
                    :postal="postal"
                    :reset-search="resetSearch"
                    v-if="!(items?.length || 0) && !isSearching"
                  />

                  <CarLandscape
                      v-for="(car, key) in items"
                      :key="car.objectID"
                      :car="car"
                      :prevCar="items[key - 1] !== undefined ? key - 1 : null"
                      :nextCar="items[key + 1] !== undefined ? key + 1 : null"
                      :appLocale="appLocale"
                      :postal="postal"
                      :getCarTotalAmount="getCarTotalAmount"
                      :getClosestDepartment="getClosestDepartment"
                      :showMoreInfo="showMoreInfo"
                      :formatDayPrices="formatDayPrices"
                      :replaceByDefault="replaceByDefault"
                      :getCommitments="getCommitments"
                      :isDefaultSort="isDefaultSort"
                      :getDepartmentCarsCount="getDepartmentCarsCount"
                      :getAvailableFrom="getAvailableFrom"
                      :initSlider="initializeSliders"
                      :isSubscriptionPage="isSubscriptionPage"
                      :hideBookingTime="hideBookingTime"
                      :getCarInfo="getCarInfo"
                      :showModal="showModal"
                      :sendEvent="sendEvent"
                  />
                  <div class="load-more" v-if="!isLastPage">
                    <button @click="handleRefineNext(refineNext)">{{ $t('layout.filters.view_more') }}</button>
                  </div>
                </template>
              </ais-infiniteHits>
            </div>
          </div>
          <InformationModal :days-count="daysCount"  v-if="!isSubscriptionPage" :car="currentCar" :get-closest-department="getClosestDepartment" :getCarInfo="getCarInfo" :appLocale="appLocale"/>
          <dialog class="modal" tabindex="-1" id="car-detail-popup">
            <div class="modal-box main-cars-details lg:!max-w-[1132px] !min-h-full !max-h-full !w-full !max-w-full !rounded-none !p-0 lg:!bg-transparent">
              <div class="lg:pr-6 lg:py-7 lg:pl-8 lg:mx-24 bg-white lg:rounded-3xl relative">
                <div class="all-products-popup-slider slick-slider" id="all-products-popup-slider">
                  <button class="slide-arrow prev-arrow slick-arrow" :class="{'slick-disabled': prevCar === null}" @click.prevent="moveCarSlider(prevCar)" aria-disabled="true"><i class="fa-solid fa-chevron-left"></i></button>
                  <CarModal
                    :car="currentCar"
                    :appLocale="appLocale"
                    :countryIso="countryIso"
                    :trustPilotBusinessId="trustPilotBusinessId"
                    :trustPilotLink="trustPilotLink"
                    :mapsApiKey="mapsApiKey"
                    :carMileageUnits="carMileageUnits"
                    :postal="postal"
                    :startingFrom="startingFrom"
                    :getFormRoute="getFormRoute"
                    :getCarTotalAmount="getCarTotalAmount"
                    :getClosestDepartment="getClosestDepartment"
                    :getDepartmentName="getDepartmentName"
                    :replaceByDefault="replaceByDefault"
                    :toggleExpandable="toggleExpandable"
                    :getCommitments="getCommitments"
                    :getAvailableFrom="getAvailableFrom"
                    :termsAndConditionContent="termsAndConditionContent"
                    :termsAndConditionPage="termsAndConditionPage"
                    :getCarPositionInCarList="getCarPositionInCarList"
                    :cancellationPolicyContent="cancellationPolicyContent"
                    :initSlider="initializeSliders"
                    :lengthUnit="lengthUnit"
                    :lengthCalculationUnit="lengthCalculationUnit"
                    :massUnit="massUnit"
                    :pushDataLayer="pushDataLayer"
                    :isSubscriptionPage="isSubscriptionPage"
                    :getCarInfo="getCarInfo"
                    :generateDateRange="generateDateRange"
                    :showModal="showModal"
                    :americanAddressFormat="americanAddressFormat"
                    :sendEvent="algoliaSendEvent"
                    :sendImpressionClick="sendImpressionClick"
                  />
                  <button class="slide-arrow next-arrow slick-arrow" @click.prevent="moveCarSlider(nextCar)" :class="{'slick-disabled': nextCar === null}" aria-disabled="false"><i class="fa-solid fa-angle-right"></i></button>
                </div>
              </div>
            </div>
          </dialog>
          <!--          <div class="loading-spinner-icon">-->
          <!--            <div class="my-10 text-center block" role="status">-->
          <!--              <svg class="animate-spin fill-oscar-orange text-[#fe660c29] h-[45px] w-[45px] m-auto text-center" aria-hidden="true" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">-->
          <!--                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"></path>-->
          <!--                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"></path>-->
          <!--              </svg><span class="sr-only">Loading...</span>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>
    </div>
  </ais-instant-search>
</template>
<script>
import VueSlider from 'vue-slider-component';
import algoliasearch from 'algoliasearch/lite';
import {
  AisSortBy,
  AisInstantSearch,
  AisConfigure,
  AisClearRefinements,
  AisStats,
  AisHitsPerPage,
  AisHighlight,
  AisPanel,
  AisToggleRefinement,
  AisRangeInput,
  AisSearchBox,
  AisInfiniteHits,
  AisCurrentRefinements,
  // AisRefinementList,
} from 'vue-instantsearch/vue3/es';

import CarLandscape from './CarLandscape.vue';
import CarModal from './CarModal.vue';
import AisRefinementList from '../vendor/RefinementList.vue';
// import RefinementCounter from './subscription/RefinementCounter.vue';
// import RefinementMap from "./subscription/RefinementMap.vue";
import { dayjs, momentify } from '../../dateUtils'
import {defineAsyncComponent} from "vue";
import RefinementLabel from "./RefinementLabel.vue";
import { createInsightsMiddleware } from "instantsearch.js/es/middlewares";
import aa from "search-insights";
import mapconfig from "../../../../customer/js/components/map-config";
import InformationModal from "../../../../customer-v3/js/components/InformationModal.vue";
const DepartmentsMap = defineAsyncComponent(() => import('../../../../customer/js/components/DepartmentsMap.vue'));
import NoResultsFound from "./NoResultsFound.vue";
import {history as historyRouter} from "instantsearch.js/es/lib/routers";
import Nudge from './nudges/Nudge.vue'
import NudgesBlock from './nudges/NudgesBlock.vue'
import {normalizePriceToMysql, normalizePriceToApp} from "../../numberUtils";

const insightsMiddleware = createInsightsMiddleware({
  insightsClient: aa,
  insightsInitParams: {
    useCookie: true,
  },
});

const middlewares = [insightsMiddleware];
const searchClient = algoliasearch(window.scoutAppId, window.scoutApiKey);
const indexName = window.scoutIndex;

export default {
  computed: {
    mapconfig() {
      return mapconfig
    },
    departmentsForMap() {
      return window.departments.filter(department => department.distance <= this.radius);
    },
    departmentIdsForMap() {
      return this.departmentsForMap.map(department => department.id);
    }
  },
  components: {
    NoResultsFound,
    DepartmentsMap,
    InformationModal,
    RefinementLabel,
    CarLandscape,
    CarModal,
    VueSlider,
    AisSortBy,
    AisInstantSearch,
    AisConfigure,
    AisClearRefinements,
    AisStats,
    AisHitsPerPage,
    AisHighlight,
    AisPanel,
    AisRefinementList,
    AisRangeInput,
    AisSearchBox,
    AisToggleRefinement,
    AisInfiniteHits,
    // RefinementCounter,
    // RefinementMap,
    AisCurrentRefinements,
    Nudge,
    NudgesBlock,
  },
  data() {
    var sortOptions = {
      [indexName]: {value: indexName, label: this.$t('layout.filters.subscription.sort_by_distance')},
      [`${indexName}_min_price_asc`]: {
        value: `${indexName}_min_price_asc`,
        label: this.$t('layout.filters.subscription.sort_by_price_asc')
      },
      [`${indexName}_min_price_desc`]: {
        value: `${indexName}_min_price_desc`,
        label: this.$t('layout.filters.subscription.sort_by_price_desc')
      },
    };

    if (!window.postal) {
      delete sortOptions[indexName];
    }

    if (!window.isSubscriptionPage) {
      sortOptions = {
        [indexName]: {value: indexName, label: this.$t('layout.filters.subscription.sort_by_distance')},
      };
    }
    const filters = [];

    if (window.isSubscriptionPage) {
      filters.push('car_subscription:true');
    }

    if (window.isSubscriptionPage && window.marketId != null && window.marketId !== '') {
      filters.push(`market_id=${window.marketId}`);
    }

    if (window.startingFrom && window.isSubscriptionPage) {
      filters.push(`available_from_timestamp <= ${window.startingFromTimestamp}`);
    }

    if (Object.values(window.carIds).length && window.isSubscriptionPage) {
      filters.push(`(${Object.values(window.carIds).map(carId => `objectID:"App\\Models\\Car::${carId}"`).join(' OR ')})`);
    }

    if (window.age && +window.age < 26) {
      filters.push(`age_restriction <= ${window.age} OR has_age_restriction=0`);
    }

    const selectedDepartments = {};
    (window.departments || []).forEach(department => {
      selectedDepartments[department.id] = false;
    });

    return {
      algoliaSendEvent: () => {},
      userToken: '',
      isSubscriptionPage: window.isSubscriptionPage,
      isSearching: false,
      hideBookingTime: window.hideBookingTime,
      isSubscriptionRequestFormActive: window.isSubscriptionRequestFormActive || false,
      form: null,
      appName: window.appName,
      slickSlider: null,
      errors: window.errors,
      dataLayer: window.dataLayer,
      bookingId: window.bookingId || 0,
      departmentId: window.departmentId || 0,
      userDepartmentsIds: window.userDepartmentsIds || [],
      mapsApiKey: window.mapsApiKey,
      typeGroup: window.typeGroup,
      daysCount: window.daysCount,
      postal: window.postal,
      pickupAt: window.pickupAt,
      deliveryAt: window.deliveryAt,
      termsAndConditionContent: window.termsAndConditionContent,
      termsAndConditionPage: window.termsAndConditionPage,
      cancellationPolicyContent: window.cancellationPolicyContent,
      step2Route: window.step2Route,
      filters: filters !== null ? filters.join(' AND ') : null,
      carIds: window.carIds,
      cars: window.cars,
      middlewares: middlewares,
      departments: window.departments,
      checkedCount: 0,
      carsInDepartments: {},
      carMileageUnits: window.carMileageUnits,
      lengthUnit: window.lengthUnit,
      lengthCalculationUnit: window.lengthCalculationUnit,
      massUnit: window.massUnit,
      coordinates: window.coordinates,
      zoom: window.zoom,
      latitude: window.latitude,
      longitude: window.longitude,
      distanceUnitShort: window.distanceUnit,
      minRadius: 5,
      maxRadius: parseInt(window.maxRadius),
      radius: parseInt(window.maxRadius),
      scoutIndex: window.scoutIndex,
      reviewCount: window.reviewCount,
      appLocale: window.appLocale,
      csPhone: window.csPhone,
      csEmail: window.csEmail,
      countryIso: window.countryIso,
      trustPilotBusinessId: window.trustPilotBusinessId,
      trustPilotLink: window.trustPilotLink,
      carTypes: window.carTypes,
      searchPanelClassNames: {'ais-Panel': 'sidebar__widget sidebar__widget--search'},
      expandablePanelClassNames: {'ais-Panel': 'sidebar__widget sidebar__widget--expandable'},
      locationsPanelClassNames: {'ais-Panel': 'sidebar__widget sidebar__widget--radius-locations'},
      towhookPanelClassNames: {'ais-Panel': 'sidebar__widget sidebar__widget--towhook'},
      featuresPanelClassNames: {'ais-Panel': 'sidebar__widget sidebar__widget--expandable sidebar__widget--features'},
      seatsPanelClassNames: {'ais-Panel': 'sidebar__widget sidebar__widget--expandable sidebar__widget--seats'},

      days: [
        this.$t('calendar.week_day.sunday.long'),
        this.$t('calendar.week_day.monday.long'),
        this.$t('calendar.week_day.tuesday.long'),
        this.$t('calendar.week_day.wednesday.long'),
        this.$t('calendar.week_day.thursday.long'),
        this.$t('calendar.week_day.friday.long'),
        this.$t('calendar.week_day.saturday.long'),
      ],
      sortOptions,
      sortByOptions: Object.values(sortOptions),
      algoliaCars: [],
      departmentsGeo: {},
      currentFilteredCars: [],
      hideLoader: false,
      noAjax: window.noAjax || false,
      currentCar: {
        subscription_pickup_notice: 0,
        type: {name: {}},
        brand: {},
        model: {},
        departments: [{excess_packages: {}, city: {}, opening_timing: {}, name: {} }],
        images: [],
        features: [],
        day_prices: [],
        props: [],
        subscription_prices: {
          'calculated': {},
          'percentages': {}
        },
        seasonal_prices: {
          'calculated': {},
          'percentages': {}
        },
        availability_for_12_months: null,
        availability_for_3_months: null,
        availability_for_6_months: null,
        available_from: null,
        tags: [],
        _geoloc: [{lat: 0, lng: 0 }],
        _rankingInfo: {matchedGeoLocation: {lat: -1, lng: -1 }},
      },
      prevCar: null,
      nextCar: null,
      clearIncludedAttributes: ['min_subscription_price', 'min_day_price', `type.name.${appLocale}`, `departments.name.${appLocale}`, 'seats', 'year', `transmission.${appLocale}`, `fuel_type.${appLocale}`, `features.${appLocale}`, 'departments.key_box', 'has_tow_hook', 'brand.name'],
      indexName,
      searchClient,
      currentIndex: window.scoutIndex,
      startingFromTimestamp: window.startingFromTimestamp,
      startingFrom: window.startingFrom,
      formattedStartingFrom: window.startingFrom ? momentify(window.startingFrom).format(window.dateFormat) : null,
      currency: window.currency,
      isDepFilter: false,
      range: null,

      defaultMinPrice: 0,
      defaultMaxPrice: 0,
      rangeInputMin: 0,
      rangeInputMax: 0,
      priceInputMin: 0,
      priceInputMax: 0,
      currentRefinements: [],

      sidebarOpened: false,
      nudgeHide: {
        hideInfoBox: true,
        noResult: true,
      },
      lowestPrice: {},

      showMoreEnabled: {
        carTypes: false,
        brand: false,
        features: false,
        fuel_type: false
      },
      noResultsLink: window.noResultsLink,
      viewItemListFired: false,

      departmentsCount: window.departmentsCount,
      visibleCarsCount: window.visibleCarsCount,
      suggestedExtensionDiscount: window.suggestedExtensionDiscount,
      secureForFeeData: window.secureForFeeData,
      carsMinTotal: 0,
      availableCarsCount: 0,
      isWeekendBooking: window.isWeekendBooking,
      selectedDepartments: selectedDepartments,

      rangeInputObserver: null,
      isShowingMoreDepartmentList: false,
      americanAddressFormat: window.americanAddressFormat,
      departmentsMapClicked: false,
      nbHits: 0,

      routing: {
        router: historyRouter(),
        stateMapping: {
          stateToRoute(uiState) {
            const indexUiState = uiState[indexName];

            return {
              refinementList: indexUiState.refinementList || {},
              toggle: indexUiState.toggle || {},
              range: indexUiState.range || {},
              type_group: window.typeGroup,
              postal: window.postal,
              pickup_at: window.pickupAt,
              delivery_at: window.deliveryAt,
            }

          },
          routeToState(routeState) {
            return {
              [indexName]: {
                refinementList: routeState.refinementList,
                toggle: routeState.toggle,
                range: routeState.range,
              },
            };
          },
        }
      },

      showingFutureCars: false,
    };
  },
  mounted() {
    const $this = this;

    aa('getUserToken', null, (err, newUserToken) => {
      if (err) {
        console.error(err);
        return;
      }

      this.userToken = newUserToken || this.userToken;
    });

    if (!window.isSubscriptionPage) {
      if ($this.departmentsCount) {
        this.loadCars(window.departments);
      } else {
        $('#page-skeleton-desktop').hide();
        $('#page-skeleton-mobile').hide();
      }
    }

    setTimeout(() => {
      this.waitToBuildRangeInputs();

      if (window.carType && window.isSubscriptionPage) {
        this.selectCarType(window.carType)
      }

      if (window.brandName && window.isSubscriptionPage) {
        this.selectBrandName(window.brandName)
      }
    }, 1000);
  },
  watch: {
    radius(newVal) {
      if (!newVal) {
        this.radius = this.minRadius;
      }
    },
    selectedDepartments: {
      handler(newVal, oldVal) {
        let selected = [];
        for (let key in newVal) {
          if (!newVal[key]) {
            continue;
          }

          selected.push({ id: parseInt(key) });
        }

        const departments = !selected.length
          ? window.departments
          : selected
        this.loadCars(departments);
      },
      deep: true
    },
    priceInputMin(newVal) {
      if (newVal.length === 0) {
        this.priceInputMin = this.formatPrice(this.defaultMinPrice);
        return;
      }
    },
    priceInputMax(newVal) {
      if (newVal.length === 0) {
        this.priceInputMax = this.formatPrice(this.defaultMaxPrice);
        return;
      }
    },
  },
  methods: {
    loadCars(departments) {
      if (this.noAjax) {
        this.isSearching = false;
        this.hideLoader = true;
        this.cars = window.cars || [];
        this.filters = window.carIds.map(carId => `objectID:"App\\Models\\Car::${carId}"`).join(' OR ') || 'objectID:0';
        window.carIds = [...new Set(window.carIds)];
        this.carIds = window.carIds;
        this.availableCarsCount = window.carIds.length;
        this.carsMinTotal = (window.secureForFeeData && window.cars.length) ? Math.min(...window.cars.map(car => car.total_amount)) : 0;

        setTimeout(() => {
          if (!this.isSubscriptionPage) {
            this.sendImpressionCars();
          }
          this.buildRangeInputs();
          $('#page-skeleton-desktop').hide();
          $('#page-skeleton-mobile').hide();
        }, 1000);

        return;
      }
      this.isSearching = true;
      this.hideLoader = false;
      const searches = [];

      window.impressionCars = [];
      window.cars = [];
      window.carIds = [];
      this.filters = [];
      this.checkedCount = 0;

      for (const department of departments) {
        searches.push(
          $.get(window.availableCarsForLocationUrl
            .replace('_type_id_', this.typeGroup || '')
            .replace('_pickup_at_', this.pickupAt || '')
            .replace('_delivery_at_', this.deliveryAt || '')
            .replace('_department_id_', department.id || '')
            .replace('_postal_', this.postal || '')
            .replace('_age_', (window.age && +window.age < 26) ? window.age : '')
          ).then(response => {
            if (typeof phpdebugbar !== 'undefined') {
              phpdebugbar.addDataSet(response._debugbar);
            }
            const impressionCars = response.cars.map(car => car.impression);
            const cars = response.cars.map(car => car.info);
            const carIds = cars.map(car => car.id);

            window.impressionCars = window.impressionCars.concat(impressionCars);
            window.cars = window.cars.concat(cars);
            window.carIds = window.carIds.concat(carIds);
            this.checkedCount++;
            this.carsInDepartments[department.id] = cars.length;
          })
        );
      }
      $.when.apply($, searches).then(() => {
        window.carIds = [...new Set(window.carIds)];
        this.isSearching = false;
        this.hideLoader = true;
        this.cars = window.cars || [];
        this.carIds = window.carIds;
        this.filters = window.carIds.map(carId => `objectID:"App\\Models\\Car::${carId}"`).join(' OR ') || 'objectID:0';
        this.availableCarsCount = window.carIds.length
        this.carsMinTotal = (window.secureForFeeData && window.cars.length) ? Math.min(...window.cars.map(car => car.total_amount)) : 0
        setTimeout(() => {
          if (!this.isSubscriptionPage) {
            this.sendImpressionCars();
          }

          this.waitToBuildRangeInputs();
          $('#page-skeleton-desktop').hide();
          $('#page-skeleton-mobile').hide();
        }, 1000);
      });
    },
    validateRadius(event) {
      event.target.value = event.target.value.replace(/[^0-9.,]/g, '');
    },
    onKeydownRadius(event) {
      const maxRadiusLength = this.maxRadius.toString().length;
      if (
        (
          !(+event.key >= 0 && +event.key <= 9)
            && event.key !== 'Backspace'
            && event.key !== 'Delete'
            && event.key !== 'ArrowLeft'
            && event.key !== 'ArrowRight'
            && event.key !== 'ArrowUp'
            && event.key !== 'ArrowDown'
            && event.key !== 'Tab'
        ) || (
          (+event.key >= 0 && +event.key <= 9)
            && event.target.value.length >= maxRadiusLength
        )
      ) {
        event.preventDefault();
        return false;
      }
    },
    waitToBuildRangeInputs() {
      const show = () => {
        this.buildRangeInputs();

        if (window.carType && window.isSubscriptionPage) {
          this.selectCarType(window.carType);
        }

        if (window.brandName && window.isSubscriptionPage) {
          this.selectBrandName(window.brandName);
        }
      };

      if (document.getElementById('range-min') && document.getElementById('range-max')) {
        show();
        return;
      }

      if (this.rangeInputObserver) {
        this.rangeInputObserver.disconnect();
        this.rangeInputObserver = null;
      }

      this.rangeInputObserver = new MutationObserver(async (mutations, obs) => {
        if (document.getElementById('range-min') && document.getElementById('range-max')) {
          obs.disconnect();
          this.rangeInputObserver = null;

          show();
        }
      });

      this.rangeInputObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    },
    async buildRangeInputs() {
      await this.$nextTick();

      if (!this.$refs.rangeInputMinEl || !this.$refs.rangeInputMaxEl) {
        return;
      }

      let { min, max } = this.$refs.rangeInputMinEl;

      const params = new URLSearchParams(decodeURIComponent(window.location.search));
      const rangeParam = params.get(`range[${this.isSubscriptionPage ? 'min_subscription_price' : 'min_day_price'}]`);
      if (rangeParam) {
        const [minPrice, maxPrice] = params.get(`range[${this.isSubscriptionPage ? 'min_subscription_price' : 'min_day_price'}]`)?.split(':') || [];
        if (minPrice?.length > 0) {
          min = this.isSubscriptionPage ? normalizePriceToApp(parseInt(minPrice)) : minPrice;
        }
        if (maxPrice?.length > 0) {
          max = this.isSubscriptionPage ? normalizePriceToApp(parseInt(maxPrice)) : maxPrice;
        }
      }

      this.defaultMinPrice = min;
      this.priceInputMin = this.formatPrice(min);
      this.rangeInputMin = min;
      this.defaultMaxPrice = max;
      this.priceInputMax = this.formatPrice(max);
      this.rangeInputMax = max;

      this.refinePriceInput({ target: { id: 'range-max', min: this.$refs.rangeInputMinEl.min, max: this.$refs.rangeInputMinEl.max } }, {});
      this.refinePriceInput({ target: { id: 'range-min', min: this.$refs.rangeInputMinEl.min, max: this.$refs.rangeInputMinEl.max } }, {});
    },
    getCarPositionInCarList(car) {
      return this.algoliaCars.findIndex((algoliaCar) => car.id == algoliaCar.id || car.car_id == algoliaCar.id) + 1;
    },
    getCarInfo(carId) {
      if (!carId) {
        return {};
      }
      if (!this.cars || !Array.isArray(this.cars)) {
        return {};
      }
      return this.cars.find(car => car.id == carId || car.car_id == carId) || {};
    },
    generateDateRange(includeYearIfSame = true) {
      const start = momentify(this.pickupAt);
      const end = momentify(this.deliveryAt);

      const startFormat = 'MMM DD';
      const endFormatSameMonth = 'DD';
      const endFormatDifferentMonth = 'MMM DD';
      const yearFormat = ', YYYY';

      if (start.isSame(end, 'year')) {
        if (start.isSame(end, 'month')) {
          if (includeYearIfSame) {
            return `${start.format(startFormat)} – ${end.format(endFormatSameMonth + yearFormat)}`;
          }
          return `${start.format(startFormat)} – ${end.format(endFormatSameMonth)}`;
        } else {
          if (includeYearIfSame) {
            return `${start.format(startFormat)} – ${end.format(endFormatDifferentMonth + yearFormat)}`;
          }
          return `${start.format(startFormat)} – ${end.format(endFormatDifferentMonth)}`;
        }
      } else {
        return `${start.format(startFormat + yearFormat)} - ${end.format(endFormatDifferentMonth + yearFormat)}`;
      }
    },
    pushDataLayer(trackingEventName, car) {
      let eventObj = {};
      eventObj.event = trackingEventName;
      eventObj.experiment_variant = 'oscar_page';
      if (trackingEventName === 'select_item') {
        eventObj.item_list_id = window.eecItemListId;
        eventObj.item_list_name = window.eecList;
      }
      if (trackingEventName === 'view_item') {
        eventObj.currency = this.currency;
        eventObj.value = this.getCarTotalAmount(car, this.isSubscriptionPage ? 'subscription' : 'rental');
      }
      let carPositionIndex = this.algoliaCars.findIndex((algoliaCar) => car.id == algoliaCar.id || car.car_id == algoliaCar.id) + 1;
      const closestDepartment = this.getClosestDepartment(car);
      if (closestDepartment) {
        const item = {
          item_id: `${car.id}_${closestDepartment.id}`,
          item_name: `${car.brand.name} ${car.model.name}`,
          index: carPositionIndex,
          item_brand: car.brand.name,
          item_category: car.type.group.name[this.appLocale],
          item_category2: car.type.name[this.appLocale],
          item_category3: closestDepartment.name[this.appLocale],
          item_list_id: window.eecItemListId,
          item_list_name: window.eecList,
          item_variant: car.model.name,
          price: this.getCarTotalAmount(car, this.isSubscriptionPage ? 'subscription' : 'rental'),
          quantity: 1,
        }
        if (this.isSubscriptionPage) {
          item.item_category4 = car.commitment_period.map(period => (period['en'] || period[this.appLocale]).toLowerCase()).join(', ');
        }
        eventObj.items = [item];
      }
      this.dataLayer.push(eventObj);
    },
    sendImpressionCars() {
      const criteoCars = window.impressionCars.map(car => car.id);

      window.dataLayer.push({
        hasCars: criteoCars.length !== 0,
        carsCount: criteoCars.length,
        departmentsChecked: this.noAjax ? window.departmentsCount : this.checkedCount,
      });
      if (window.impressionCars.length) {
        window.dataLayer.push({
          criteo: {
            1: {
              event: 'viewSearch',
              checkin_date: this.pickupAt,
              checkout_date: this.deliveryAt,
            },
            2: {
              event: 'viewList',
              item: criteoCars,
            },
          },
          facebook: {
            event: 'Search',
            data: {
              checkin_date: this.pickupAt,
              checkout_date: this.deliveryAt,
              items: criteoCars,
            },
          },
        });
      }
      window.dataLayer.push({
        event: 'eec.impressionView',
        experiment_variant: 'oscar_page',
        ecommerce: {
          currencyCode: window.currency,
          impressions: window.impressionCars,
        }
      });
    },
    sendImpressionClick(car) {
      if (this.isSubscriptionPage) {
        return true;
      }
      window.dataLayer.push({
        event: 'eec.impressionClick',
        ecommerce: {
          click: {
            actionField: {
              list: window.eecList,
              item_list_id: window.eecItemListId,
            },
            currencyCode: window.currency,
            products: [{
              id: `${car.id}_${this.getClosestDepartment(car).id}`,
              name: `${car.brand.name} ${car.model.name}`,
              category: (car.type.group.name && car.type.group.name.en) || car.type.group.name,
              item_category2: (car.type.name && car.type.name.en) || car.type.name,
              item_category3: (this.getClosestDepartment(car).name && this.getClosestDepartment(car).name.en) || this.getClosestDepartment(car).name,
              price: car.min_day_price,
              quantity: 1,
              brand: car.brand.name,
              variant: car.model.name,
            }],
          },
        },
      });
    },
    transformItemsVehicleType(items, {results}) {
      const availableVehicleTypes = Object.values(
        results.facets.find(facet => facet.name === `type.name.${this.appLocale}`)?.data ||
        results.disjunctiveFacets.find(facet => facet.name === `type.name.${this.appLocale}`)?.data ||
        {}
      );
      this.showMoreEnabled.carTypes = availableVehicleTypes.length > 5;
      return items;
    },
    transformItemsBrand(items, {results}) {
      const availableBrand = Object.values(
        results.facets.find(facet => facet.name === `brand.name`)?.data ||
        results.disjunctiveFacets.find(facet => facet.name === `brand.name`)?.data ||
        {}
      );
      this.showMoreEnabled.brand = availableBrand.length > 5;
      return items;
    },
    transformItemsFeatures(items, {results}) {
      const availableFeatures = Object.values(
        results.facets.find(facet => facet.name === `features.${this.appLocale}`)?.data ||
        results.disjunctiveFacets.find(facet => facet.name === `features.${this.appLocale}`)?.data ||
        {}
      );
      this.showMoreEnabled.features = availableFeatures.length > 5;
      return items;
    },
    transformItemsFuelType(items, {results}) {
      const availableFeatures = Object.values(
        results.facets.find(facet => facet.name === `fuel_type.${this.appLocale}`)?.data ||
        results.disjunctiveFacets.find(facet => facet.name === `fuel_type.${this.appLocale}`)?.data ||
        {}
      );
      this.showMoreEnabled.fuel_type = availableFeatures.length > 5;
      return items;
    },
    selectCarType(carType) {
      this.$refs.vehicleTypeRefinementList.refine(carType);
    },
    selectBrandName(brandName) {
      this.$refs.brandRefinementList.refine(brandName);
    },
    transformCurrentRefinements(items, {results}) {
      this.currentRefinements = items;
      return items;
    },
    isDesktopOrTablet() {
      return window.innerWidth > 767; // Adjust the breakpoint as needed
    },
    toValue(value, range) {
      return [
        typeof value.min === 'number' ? this.normalizePriceToApp(value.min) : this.normalizePriceToApp(range.min),
        typeof value.max === 'number' ? this.normalizePriceToApp(value.max) : this.normalizePriceToApp(range.max),
      ];
    },
    getCarTotalAmount(car, type = 'subscription') {
      if (type === 'subscription') {
        if (car.subscription_prices) {
          let prices = Object.values(car.subscription_prices.calculated);
          let normalizedPrices = prices.map(price => this.normalizePriceToApp(price));
          return Math.min(...normalizedPrices);
        }
      }
      if (type === 'rental') {
        const carInfo = this.getCarInfo(car.id);
        return carInfo.total_amount;
      }
      return 0;
    },
    getCarTotalAmountPerPeriod(car) {
      if (car.subscription_prices) {
        let prices = {};
        for (let period in car.subscription_prices.calculated) {
          const monthNumber = period.split('_')[1];
          prices[monthNumber] = this.normalizePriceToApp(car.subscription_prices.calculated[period] || 9999999);
        }
        return prices;
      }
      return {};
    },
    formatDayPrices(dayPrices) {
      const daysOrder = [1, 2, 3, 4, 5, 6, 0];
      let newDayPrices = {};
      for (let order in daysOrder) {
        newDayPrices[order] = {
          price: this.formatPrice(dayPrices[daysOrder[order]]),
          weekDay: this.days[daysOrder[order]],
        };
      }
      return newDayPrices;
    },
    handleCarsFromAlgolia(items, ref) {
      this.nbHits = ref.results.nbHits
      this.hideLoader = true;
      this.$nextTick(function () {
        lazyload();
      });
      this.currentFilteredCars = items;
      this.departmentsGeo = this.departments.reduce((acc, department) => {
        const departmentName = department.name;
        acc[departmentName] = {
          lat: department.lat,
          lng: department.lng,
          distance: department.distance,
        }
        return acc;
      }, {});
      this.departmentsGeo = items.reduce((acc, car) => {
        if (!car.departments?.length) return acc;

        car.departments.forEach((department, index) => {
          if (!department?.name || !car._geoloc?.[index]) {
            return;
          }

          const departmentName = department.name[this.appLocale];
          if (departmentName && !acc[departmentName]) {
            acc[departmentName] = {
              lat: car._geoloc[index].lat,
              lng: car._geoloc[index].lng,
            };
          }
        });

        return acc;
      }, { ...this.departmentsGeo });
      this.algoliaCars.push(...items);
      this.algoliaCars = [...new Map(this.algoliaCars.map(item => [item['id'], item])).values()];
      const lowestPrice = this.algoliaCars.map(car => this.getCarTotalAmountPerPeriod(car))
      const periods = [...new Set(lowestPrice.flatMap(price => Object.keys(price)))];
      this.lowestPrice = periods.reduce((acc, period) => {
        acc[period] = Math.min(...lowestPrice.map(price => price[period] || 999999));
        return acc;
      }, {});

      if (this.isSubscriptionPage) {
        if (items.length === 0 && this.filters.includes('available_from_timestamp <=')) {
          this.filters = this.filters.replace('available_from_timestamp <=', 'available_from_timestamp >=');
          if (this.filters.lastIndexOf(' AND (') !== -1) {
            this.filters = this.filters.substring(0, this.filters.lastIndexOf(' AND ('));
          }
          this.showingFutureCars = true;
          return;
        }

        if (!this.viewItemListFired && items.length === 0) {
          this.viewItemListFired = true;

          window.dataLayer.push({
            event: "view_item_list",
            item_list_id: window.eecItemListId,
            item_list_name: window.eecList,
            hasCars: false,
            carsCount: 0,
            departmentsChecked: window.departments.length,
            items: []
          });
        }

        if (!this.viewItemListFired && items.length > 0) {
          this.viewItemListFired = true;

          let departmentsChecked = 0;
          const searches = [];
          let impressionCars = [];
          if (window.departments.length > 0) {
            for (const department of window.departments) {
              searches.push(
                $.get(window.availableSubscriptionCarsUrl
                  .replace('_type_name_', window.carType || '')
                  .replace('_type_group_', window.typeGroup || '')
                  .replace('_brand_name_', window.brandName || '')
                  .replace('_starting_from_', window.startingFrom || '')
                  .replace('_age_', window.age || '')
                  .replace('_department_id_', department.id)
                ).then(response => {
                  const _impressionCars = response.cars.map(car => car.impression);
                  impressionCars = [...impressionCars, ..._impressionCars];
                  departmentsChecked++;
                  this.showingFutureCars = response.showingFutureCars;
                })
              );
            }
          } else {
            searches.push(
              $.get(window.availableSubscriptionCarsUrl
                .replace('_type_name_', window.carType || '')
                .replace('_type_group_', window.typeGroup || '')
                .replace('_brand_name_', window.brandName || '')
                .replace('_starting_from_', window.startingFrom || '')
                .replace('_age_', window.age || '')
                .replace('_department_id_', '')
              ).then(response => {
                const _impressionCars = response.cars.map(car => car.impression);
                impressionCars = [...impressionCars, ..._impressionCars];
                departmentsChecked = response.departmentsChecked
                this.showingFutureCars = response.showingFutureCars;
              })
            );
          }

          $.when.apply($, searches).then(() => {
            impressionCars = impressionCars.filter((car, index, self) => {
              const carDepartment = this.getClosestDepartment(car);
              if (!carDepartment) {
                return false;
              }

              const duplicatedIndex = self.findIndex(_car => {
                const duplicatedDepartment = this.getClosestDepartment(_car);

                return _car.id === car.id && carDepartment.id === duplicatedDepartment.id;
              });

              return index === duplicatedIndex;
            });

            window.dataLayer.push({
              event: "view_item_list",
              item_list_id: window.eecItemListId,
              item_list_name: window.eecList,
              hasCars: impressionCars.length > 0,
              carsCount: impressionCars.length,
              departmentsChecked: departmentsChecked,
              items: impressionCars.map((car, index) => {
                const department = this.getClosestDepartment(car);
                if (!department) {
                  return;
                }

                return {
                  item_id: `${car.id}_${department.id}`,
                  item_name: `${car.brand.name} ${car.model.name}`,
                  index: index + 1,
                  item_brand: car.brand.name,
                  item_category: car.type.group.name,
                  item_category2: car.type.name,
                  item_category3: department.name,
                  item_category4: car.commitment_period.filter(period => period.available)
                    .map(period => `${period.months} months`)
                    .join(', ')
                    .toLowerCase(),
                  item_list_id: window.eecItemListId,
                  item_list_name: window.eecList,
                  item_variant: car.model.name,
                  price: this.getCarTotalAmount(car, this.isSubscriptionPage ? 'subscription' : 'rental'),
                  quantity: 1,
                }
              }).filter(Boolean)
            });
          });
        }
      } else {
        //$('#page-skeleton-desktop').hide();
      }

      for (let key in items) {
        items[key].distanceFromClosestLocation = this.getDistanceFromClosestLocation(items[key]);
      }

      return items;
    },
    getFormRoute() {
      return this.step2Route;
    },
    getCurrentRefinementLabel(currentRefinement) {
      return this.sortOptions[currentRefinement || this.indexName].label;
    },
    getDepartmentName(car) {
      const department = car.closestDepartment || this.getClosestDepartment(car);
      return `${this.appName} ${this.$t('department.car_rental')} ${(department && department.name[this.appLocale]) || ''}`;
    },
    getDistanceFromClosestLocation(car) {
      if (!car?._rankingInfo?.matchedGeoLocation?.distance) {
        return null;
      }

      for (let i = 0; i < car.departments.length; i++) {
        if (this.isMatchedGeo(car._geoloc[i], car)) {
          return (car._rankingInfo.matchedGeoLocation.distance / 1000).toFixed(1);
        }
      }

      return null;
    },
    getClosestDepartment(car) {
      let department = car.departments[0];
      if (this.isMatchedGeo(car._geoloc[0], car)) {
        return department;
      }
      for (let i = 1; i < car.departments.length; i++) {
        department = car.departments[i];
        if (this.isMatchedGeo(car._geoloc[i], car)) {
          return department;
        }
      }
      return car.departments[0];
    },
    getDepartmentCarsCount(id) {
      if (!id) {
        return false;
      }
      const department = this.departments.find(dep => dep.id == id);
      if (department?.cars) {
        return department.cars.length < 10 && this.postal && department.name === this.postal && this.isDefaultSort();
      }
      return false;
    },
    isMatchedGeo(geoloc, car) {
      if (!car._rankingInfo.matchedGeoLocation) {
        return true;
      }
      const lat = Math.round(geoloc.lat * 1000);
      const lng = Math.round(geoloc.lng * 1000);
      if (
        lat !== Math.round(car._rankingInfo.matchedGeoLocation.lat * 1000) &&
        (lat + 1) !== Math.round(car._rankingInfo.matchedGeoLocation.lat * 1000) &&
        (lat - 1) !== Math.round(car._rankingInfo.matchedGeoLocation.lat * 1000)
      ) {
        return false;
      }
      if (
        lng !== Math.round(car._rankingInfo.matchedGeoLocation.lng * 1000) &&
        (lng + 1) !== Math.round(car._rankingInfo.matchedGeoLocation.lng * 1000) &&
        (lng - 1) !== Math.round(car._rankingInfo.matchedGeoLocation.lng * 1000)
      ) {
        return false;
      }
      return true;
    },
    handleRefineNext(refineNext) {
      const $this = this;
      refineNext();
    },
    toggleFilters() {
      this.sidebarOpened = !this.sidebarOpened;
    },
    handleCanRefine(canRefine) {
      const $this = this;
      if ($this.range !== $this.maxRadius) {
        return true;
      }
      return canRefine;
    },
    clearFilters(refine) {
      const $this = this;
      $this.radius = $this.maxRadius;

      $('[type="search"]').val('');

      refine();
      return true;
    },
    initializeSliders(sliderQuerySelector) {
      $(sliderQuerySelector).each(function() {
        var $slider = $(this);
        var currentSlide;
        var slidesCount;
        var sliderCounter = document.createElement('div');
        sliderCounter.classList.add('slider__counter');
        var updateSliderCounter = function(slick, currentIndex) {
          currentSlide = slick.slickCurrentSlide() + 1;
          slidesCount = slick.slideCount;
          $(sliderCounter).html('<span class="slider__counter-text">' + currentSlide + '</span>' + '<span class="slider__counter-separator">/</span>' + '<span class="slider__counter-text">' + slidesCount + '</span>');
        };

        $slider.on('init', function(event, slick) {
          $slider.append(sliderCounter);
          updateSliderCounter(slick);
        });

        $slider.on('afterChange', function(event, slick, currentSlide) {
          updateSliderCounter(slick, currentSlide);
        });

        $slider.not('.slick-initialized').slick({
          nextArrow: '<button type="button" class="slick-next slick-arrow"><i class="fa-solid fa-chevron-right"></i></button>',
          prevArrow: '<button type="button" class="slick-prev slick-arrow"><i class="fa-solid fa-chevron-left"></i></button>',
          infinite: false,
        });

        $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          if (slidesCount) {
            if (nextSlide === slidesCount - 1) {
              $slider.find('.slick-next').attr('disabled', 'disabled').addClass('slick-disabled');
            } else {
              $slider.find('.slick-next').removeAttr('disabled').removeClass('slick-disabled');
            }

            if (nextSlide === 0) {
              $slider.find('.slick-prev').attr('disabled', 'disabled').addClass('slick-disabled');
            } else {
              $slider.find('.slick-prev').removeAttr('disabled').removeClass('slick-disabled');
            }
          }
        });
      });
    },
    destructSlider() {
      $('.car-img-slider-pop .slider__counter').remove();
      $(".car-img-slider-pop").off('init');
      $(".car-img-slider-pop").off('afterChange');
      $(".car-img-slider-pop").off('beforeChange');
      $(".car-img-slider-pop").slick('unslick');
    },
    moveCarSlider(carIndex) {
      if (carIndex === null) {
        return;
      }
      this.destructSlider();
      if (this.currentFilteredCars[carIndex] !== undefined) {
        this.currentCar = this.clone(this.currentFilteredCars[carIndex]);

        //hack for slick if car.images length is zero
        this.removeCarImageIfNotExist()
      }

      const $this = this;
      $this.$nextTick(function () {
        $this.initializeSliders('.car-img-slider-pop');
        this.pushDataLayer('view_item', this.currentCar);
        lazyload();
        this.algoliaSendEvent('click', this.currentCar, 'View more info');
      });

      this.nextCar = this.currentFilteredCars[carIndex + 1] && carIndex !== null ? carIndex + 1 : null;
      this.prevCar = this.currentFilteredCars[carIndex - 1] !== undefined ? carIndex - 1 : null;
    },

    //hack for slick if car.images length is zero
    removeCarImageIfNotExist() {
      if (this.currentCar.images.length < 1) {
        $('.car-img').remove();
      }
    },

    showMoreInfo(car, prevCarIndex, nextCarIndex, sendEvent) {
      if (car && sendEvent) {
        this.algoliaSendEvent = sendEvent || (() => {});
        this.algoliaSendEvent('click', car, 'View more info');
      }
      if ($(".car-img-slider-pop").hasClass('slick-initialized')) {
        this.destructSlider();
      }

      this.currentCar = this.clone(car);
      //hack for slick if car.images length is zero
      this.removeCarImageIfNotExist()

      const $this = this;
      $this.$nextTick(function () {
        $this.initializeSliders('.car-img-slider-pop');
        lazyload();
        this.pushDataLayer('view_item', car);
        this.showModal('car-detail-popup', car, sendEvent);
      });
      this.prevCar = prevCarIndex;
      this.nextCar = nextCarIndex;
    },
    showDepartmentsMap() {
      this.departmentsMapClicked = true;
      this.showModal('my_map_1');
    },
    showModal(modalId, car, sendEvent) {
      if (car && sendEvent) {
        this.algoliaSendEvent = sendEvent || (() => {});
      }
      let modalObject = document.getElementById(modalId);
      if (modalObject) {
        if (modalId === 'my_information' && car) {
          this.currentCar = car;
        }
        modalObject.showModal();
        modalObject.classList.remove('hidden');
      }
    },
    toggleExpandable(e) {
      if ($(e.target).hasClass('expand')) {
        $(e.target).parents('.sidebar__widget--expandable').toggleClass('widget-collapse');
      }
      if ($(e.target).hasClass('expand-trigger')) {
        if ($(e.target).parents('.expand').hasClass('open')) {
          $(e.target).parents('.expand').removeClass('open');
          $(e.target).parents('.expand').addClass('closed');
        } else if ($(e.target).parents('.expand').hasClass('closed')) {
          $(e.target).parents('.expand').removeClass('closed');
          $(e.target).parents('.expand').addClass('open');
        }
      }
    },
    replaceByDefault(e) {
      e.target.src = '/img/sub_car_placeholder_new.png';
    },
    setSeatsLabel(items) {
      return items.map(item => ({
        ...item,
        label: `${this.$t('layout.filters.seats')} ${item.label}`,
      }));
    },
    check6Availability(availableFromDate, availability6Months, availability12Months) {
      if (availability6Months
        && availability6Months.isSameOrBefore(availableFromDate)) {

        if (!availability12Months) {
          return true;
        }

        if (availability12Months && availability12Months.isAfter(availability6Months) && availability12Months.diff(availableFromDate, 'months', true) >= 6) {
          return true;
        }
        if (availability12Months && availability6Months.isSame(availability12Months)) {
          return true;
        }
      }
      return false;
    },
    getCommitments(car) {

      let tiers = [];

      if (this.startingFrom) {
        const availableFromDate = momentify(this.getAvailableFrom(car));
        const availability3Months = car.availability_for_3_months ? momentify(car.availability_for_3_months) : '';
        const availability6Months = car.availability_for_6_months ? momentify(car.availability_for_6_months) : '';
        const availability12Months = car.availability_for_12_months ? momentify(car.availability_for_12_months) : '';

        if (
          availability3Months &&
          availability3Months.isSame(availability6Months) &&
          availability3Months.isSame(availability12Months)
        ) {
          tiers.push('3', '6', '12');
        } else {
          if (availability3Months &&
            availability3Months.isSameOrBefore(availableFromDate)
          ) {
            tiers.push('3');
          }
          if (this.check6Availability(availableFromDate, availability6Months, availability12Months)) {
            tiers.push('6');
          }
          if (availability12Months && availability12Months.isSameOrBefore(availableFromDate)) {
            tiers.push('12');
          }
        }

      } else {
        if (car.availability_for_3_months) {
          tiers.push('3');
        }

        if (car.availability_for_6_months) {
          tiers.push('6');
        }

        if (car.availability_for_12_months) {
          tiers.push('12');
        }
      }


      if (tiers.length === 1) {
        return tiers[0] + ' ' + this.$t('layout.subscription.months');
      }

      if (tiers.length === 2) {
        return tiers.join(' ' + this.$t('layout.subscription.and') + ' ') + ' ' + this.$t('layout.subscription.months');
      }

      if (tiers.length > 2) {
        const lastTwoTiers = tiers.slice(-2).join(' ' + this.$t('layout.subscription.and') + ' ');
        const remainingTiers = tiers.slice(0, -2).join(', ');
        return remainingTiers + ', ' + lastTwoTiers + ' ' + this.$t('layout.subscription.months');
      }

      return '';
    },

    getAvailableFrom(car) {
      let currentDate = momentify();

      if (this.startingFrom) {
        currentDate = momentify(this.startingFrom);
      }

      var noticePeriodDate = momentify().add(car.subscription_pickup_notice, 'days');

      var useNoticePeriod = false;

      if (currentDate.isSameOrAfter(momentify(), 'day') && currentDate.isSameOrBefore(noticePeriodDate, 'day')) {
        useNoticePeriod = true;
      }

      const carAvailableFromTimestamp = dayjs.unix(car.available_from_timestamp);

      if (carAvailableFromTimestamp.isSameOrBefore(currentDate)) {
        if (useNoticePeriod && carAvailableFromTimestamp.isSameOrBefore(noticePeriodDate)) {
          return noticePeriodDate.format('YYYY-MM-DD');
        }
        return currentDate.format('YYYY-MM-DD');
      }

      return car.available_from;
    },

    isDefaultSort() {
      return this.currentIndex === this.indexName;
    },
    getLocRefinementList(items) {
      this.isDepFilter = items.length > 0 ? true : false;
      return items;
    },
    onKeyupPriceInput(e, { refineFn, currentRefinement }) {
      if (e.key !== 'Backspace' && isNaN(Number(e.key))) {
        e.preventDefault();
        return false;
      }
    },
    formatRange(e) {
      const elementId = e.target.id;
      if (elementId === 'price-min') {
        this.rangeInputMin = this.parseLocaleNumber(this.priceInputMin, this.appLocale) || e.target.dataset.min;
      } else if (elementId === 'price-max') {
        this.rangeInputMax = this.parseLocaleNumber(this.priceInputMax, this.appLocale) || e.target.dataset.max;
      }
    },
    handlePriceInputChange(e, { refineFn, currentRefinement }) {
      const elementId = e.target.id;
      this.formatRange(e);

      this.refinePriceInput(
        { ...e, target: { ...e.target, id: elementId.replace('price', 'range'), dataset: e.target.dataset } },
        { refineFn, currentRefinement }
      );
    },
    refinePriceInput(e, { refineFn, currentRefinement }) {
      let { id: elementId, min, max, dataset } = e.target;
      if (min === undefined && max === undefined) {
        min = dataset.min;
        max = dataset.max;
      }

      if (elementId === 'range-max') {
        this.$refs.rangeEl.style.right = 100 - (((this.rangeInputMax - min) * 100) / (max - min)) + '%';
        this.priceInputMax = this.formatPrice(this.rangeInputMax);

        if (refineFn) {
          refineFn({
            min: currentRefinement?.min || (this.isSubscriptionPage ? normalizePriceToMysql(min) : min),
            max: this.isSubscriptionPage ? normalizePriceToMysql(this.rangeInputMax) : this.rangeInputMax
          })
        }
      } else if (elementId === 'range-min') {
        this.$refs.rangeEl.style.left = (this.rangeInputMin - min) * 100 / (max - min) + '%';
        this.priceInputMin = this.formatPrice(this.rangeInputMin);

        if (refineFn) {
          refineFn({
            min: this.isSubscriptionPage ? normalizePriceToMysql(this.rangeInputMin) : this.rangeInputMin,
            max: currentRefinement?.max || (this.isSubscriptionPage ? normalizePriceToMysql(max) : max)
          })
        }
      }

      const minPrice = this.parseLocaleNumber(this.priceInputMin, this.appLocale),
        maxPrice = this.parseLocaleNumber(this.priceInputMax, this.appLocale);
      if (maxPrice < minPrice) {
        this.priceInputMax = this.formatPrice(minPrice);
        this.rangeInputMax = minPrice;

        if(refineFn) {
          refineFn({
            min: this.rangeInputMin,
            max: this.rangeInputMax
          });
        }
      }
    },
    getCarTypeIcon(carType) {
      return this.carTypes.find(type => type.name.toLowerCase() === carType.label.toLowerCase())?.icon;
    },
    resetPriceGraph(operator = null) {
      const min = this.$refs.rangeInputMinEl.min,
        max = this.$refs.rangeInputMinEl.max;

      if (operator === '>=') {
        this.rangeInputMin = min;
        this.refinePriceInput({ target: { id: 'range-min', dataset: { min, max } } }, {})
      } else if (operator === '<=') {
        this.rangeInputMax = max;
        this.refinePriceInput({ target: { id: 'range-max', dataset: { min, max } } }, {})
      } else {
        this.resetPriceGraph('>=');
        this.resetPriceGraph('<=');
      }
    },
    resetSearch() {
      if (this.$refs.clearRefinements?.state) {
        this.$refs.clearRefinements.state.refine();
      } else {
        window.location.href = window.location.href.split('?')[0];
      }
      this.resetPriceGraph();
    },
    geoSort(a, b) {
      const refLat = window.searchedLatLong.lat;
      const refLng = window.searchedLatLong.lng;
      const aLoc = this.departmentsGeo[a.name];
      const bLoc = this.departmentsGeo[b.name];

      if (!aLoc) return 1;
      if (!bLoc) return -1;

      let aDist = this.departmentsGeo[a.name]?.distance ? this.departmentsGeo[a.name].distance : this.getDistance(refLat, refLng, aLoc.lat, aLoc.lng);
      let bDist = this.departmentsGeo[b.name]?.distance ? this.departmentsGeo[b.name].distance : this.getDistance(refLat, refLng, bLoc.lat, bLoc.lng);

      return aDist - bDist;
    },
    getDistance(lat1, lon1, lat2, lon2) {
      const R = 6371; // Earth radius in km
      const dLat = (lat2 - lat1) * Math.PI / 180;
      const dLon = (lon2 - lon1) * Math.PI / 180;
      const a =
          Math.sin(dLat/2) * Math.sin(dLat/2) +
          Math.cos(lat1 * Math.PI / 180) *
          Math.cos(lat2 * Math.PI / 180) *
          Math.sin(dLon/2) * Math.sin(dLon/2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
      return R * c;
    }
  }
};
</script>

<style scoped>
.desktop-skeleton svg {
  width: 983px;
  overflow: hidden;
}

@media (min-width: 768px) {
  .desktop-skeleton svg {
    height: 290px;
  }
}

.current-refinements-list:has(li) {
  margin-bottom: 1rem;
}

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  font-size: .75rem;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;
  text-align: center;
  background-color: #fe660c;
  transition: width .6s ease;
}

.progress-bar-stripped {
  background-image: linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);
  background-size: 1rem 1rem;
}
.progress-bar-animated {
  animation: progress-bar-stripes 1s linear infinite;
}
</style>
